<adaa-data-table
    #adaaDataTable
    [apiPrefix]="'integrity'"
    [apiName]="'getAllCamelCase'"
    [titleHeader]="'rules_management.title' | translate"
    [configKey]="Constants.MAIN_TABLE_LIST_CONF_KEY.RULES_MANAGEMENT"
    [itemTypeId]="Constants.CONSTANT_PERMISSIONS.RULES_MANAGEMENT"
    [enableViewAction]="false"
    (actionClicked)="getAction($event)"
    (addNewClicked)="addNewRule()"
></adaa-data-table>

<adaa-float-action />
